import { useEffect, useState } from "react";
import type { DrupalVideo } from "@app/types/Drupal";
import * as Sentry from "@sentry/react";
import axios from "axios";

export type DrupalVideoResponse = {
  total: number;
  results: DrupalVideo[];
};

const fetchDrupalLatestVideos = async (): Promise<DrupalVideo[]> => {
  try {
    const response = await axios.get<DrupalVideoResponse>(
      "/_plat/api/v1/latest-videos"
    );
    return response.data.results ?? [];
  } catch (e) {
    return [];
  }
};

export default function useLatestVideos(): DrupalVideo[] {
  const [data, setData] = useState<DrupalVideo[]>([]);

  useEffect(() => {
    const callFetch = async () => {
      setData(await fetchDrupalLatestVideos());
    };

    try {
      callFetch();
    } catch (error) {
      Sentry.captureException(error);
    }
  }, []);

  return data;
}
